module.exports = __webpack_public_path__ + "img/list1.0c2c25c0.png";